export class TextureError extends Error {}
